import { createContext, useContext, useState } from "react";
import Api from "../api";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [gedung, setGedung] = useState([]);
  const [ruangan, setRuangan] = useState([]);
  const [petugas, setPetugas] = useState([]);
  const [inventaris, setInventaris] = useState([]);
  const [lab,setLabs]=useState([])
  const[monitoring,setMonitoring]=useState([])
  const[perawatan,setPerawatan]=useState([])

  // Ikuti API base URL (dev/prod) agar preview foto tidak tetap ke localhost
  const apiBase = (process.env.REACT_APP_API_BASE_URL || "http://localhost:3002").replace(/\/$/, "");
  // Upload monitoring/perawatan/bangunan
  const gambar = `${apiBase}/uploads/`;
  // Foto inventaris aset (disimpan di /api/storage via multer server)
  const exgambar = `${apiBase}/api/storage/`;

 
  
  const getGedung = async () => {
    try {
      const res = await Api.get("/mon/gedung");
      if (res.data && res.data.data) {
        setGedung(res.data.data);
      } else {
        setGedung([]);
      }
    } catch (error) {
      console.error('Error fetching gedung:', error);
      setGedung([]);
    }
  };

  const getPerMon=async()=>{
    try {
      const res = await Api.get("/mon/per-mon");
      setPerawatan(res.data.perawatan);
      setMonitoring(res.data.monitoring);
    } catch (error) {
      console.error('Error fetching gedung:', error);
      setMonitoring([]);
      setPerawatan([]);
    }
  }
  
  const getRuangan = async (gid) => {
    try {
      if (!gid) {
        setRuangan([]);
        return;
      }
      const res = await Api.get("/mon/ruangan/" + gid);
      if (res.data && res.data.data) {
        setRuangan(res.data.data);
      } else {
        setRuangan([]);
      }
    } catch (error) {
      console.error('Error fetching ruangan:', error);
      setRuangan([]);
    }
  };
  
  const getPetugas = async () => {
    try {
      const res = await Api.get("/mon/petugas");
      setPetugas(res.data.data);
    } catch (error) {
      throw error;
    }
  };

  const getLabs = async () => {
    try {
      const res = await Api.get("/mon/labs");
      setLabs(res.data.data);
    } catch (error) {
      throw error;
    }
  };
  
  const getInventaris = async (kode) => {
    try {
      const res = await Api.get("/mon/inventaris/filter",{params:{kode:kode}});
      setInventaris(res.data.data || []);
    } catch (error) {
      setInventaris([]);
      throw error;
    }
  };

  return (
    <DataContext.Provider
      value={{
        gedung,
        ruangan,
        getRuangan,
        getGedung,
        setRuangan,
        petugas,
        getPetugas,
        inventaris,
        getInventaris,
        gambar,
        lab,
        getLabs,
        exgambar,
        monitoring,
        perawatan,
        getPerMon
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);